
import { useState, useEffect } from 'react';

export default function CallButton() {
  const [visible, setVisible] = useState(false);
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const heroSection = document.getElementById('home');
      if (heroSection) {
        const heroBottom = heroSection.getBoundingClientRect().bottom;
        setVisible(heroBottom < 0);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <a
      href="tel:+77074325020"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className={`fixed bottom-6 right-5 z-40 flex items-center gap-3 transition-all duration-500 cursor-pointer ${
        visible
          ? 'opacity-100 translate-y-0 scale-100'
          : 'opacity-0 translate-y-4 scale-75 pointer-events-none'
      }`}
    >
      {/* Tooltip */}
      <div
        className={`bg-white rounded-xl shadow-xl px-4 py-2.5 text-sm font-medium text-gray-800 transition-all duration-300 whitespace-nowrap hidden md:block ${
          hovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4 pointer-events-none'
        }`}
      >
        Позвонить нам
        <div className="absolute right-[-6px] top-1/2 -translate-y-1/2 w-3 h-3 bg-white rotate-45 shadow-xl" />
      </div>

      {/* Button */}
      <div className="relative">
        {/* Pulse ring */}
        <div className="absolute inset-0 bg-teal-500 rounded-full animate-ping opacity-20" />
        <div className="relative w-14 h-14 bg-gradient-to-br from-teal-500 to-emerald-600 rounded-full flex items-center justify-center shadow-2xl shadow-teal-500/40 hover:shadow-teal-500/60 hover:scale-110 transition-all duration-300">
          <i className="ri-phone-fill text-white text-2xl w-6 h-6 flex items-center justify-center"></i>
        </div>
      </div>
    </a>
  );
}
